<template>
    <div class="times-container">
        <span class="title-description">可设置多个推送时间，系统将按照推送时间定时推送</span>
        <el-form :model="pushTimesForm" inline :rules="formRule" ref="form">
            <el-form-item prop="time">
                <el-date-picker
                    size="small"
                    v-model="pushTimesForm.time"
                    type="datetime"
                    :disabled="isDetail"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :picker-options="pickerOptions"
                    placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button class="next-button"  :disabled="isDetail" type="success" size="small" @click="handleCreateTime" icon='el-icon-plus'>添加</el-button>
            </el-form-item>
        </el-form>
        <el-alert
            :title="'已添加推送时间（共'+tableData.length+'次）'"
            :closable='false'
            type="success">
        </el-alert>
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column prop="send_time" label="推送时间"></el-table-column>
            <el-table-column prop="week_day" label="周信息"></el-table-column>
            <el-table-column prop="send_status" label="推送状态"></el-table-column>
            <el-table-column prop="send_number" label="推送人数"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="handleDelete(scope.$index)" v-if="!isDetail && scope.row.send_status !== '已推送'">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button class="next-button margin-top-18" type="primary" size="small" @click="handlerNext" v-if="!isDetail">下一步</el-button>
    </div>
</template>
<script>
import { mapState } from "vuex";
const week = ['周日','周一','周二','周三','周四','周五','周六']
export default {
    name: 'push-times',
    data() {
        return {
            pushTimesForm: {
                time: ''
            },
            tableData: [],
            formRule: {
                time: [{
                    required: true, message: ' ', trigger: ['blur', 'change']
                }]
            },
            pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				},
			}
        }
    },
    computed: {
        ...mapState(['$moment']),
        ...mapState('pushPushPlanOperate', ['data']),
    },
    props: ['isDetail', 'isCopy'],
    watch: {
        data: {
            handler() {
                if(Array.isArray(this.data.send_time_list) && this.data.send_time_list.length) {
                    this.tableData = this.data.send_time_list.map(item => {
                        return {
                            send_time: this.$moment(item.send_time, 'X').format('YYYY-MM-DD HH:mm'),
                            week_day: week[this.$moment(item.send_time, 'X').day()],
                            send_status: item.send_status ? '已推送' : '未推送',
                            send_number: item.send_number ? item.send_number : '--'
                        }
                    });
                    if(this.isCopy) {
                        this.tableData = this.tableData.filter(item => item.send_status !== '已推送');
                    }
                }
            },
            deep: true 
        }
    },
    methods: {
        handlerNext() {
            const times = this.tableData.map(item => this.$moment(item.send_time).unix())
            if(!times.length) {
                this.$alert('请添加推送时间！');
                return;
            }
            this.$emit('submit', {time_config: times}, 4)
        },
        handleCreateTime() {
            this.$refs['form'].validate((valid) => {
                if(valid) {
                    if(this.$moment(this.pushTimesForm.time).unix() < this.$moment().unix()) {
                        this.$alert('请选择未来的时间！');
                        return;
                    }
                    const times = this.tableData.map(item => item.send_time);
                    if(times.indexOf(this.pushTimesForm.time) > -1) {
                        this.$alert('添加的推送时间重复，请重试！')
                    }else {
                        this.tableData.push({
                            send_time: this.pushTimesForm.time,
                            week_day: week[this.$moment(this.pushTimesForm.time).day()],
                            send_status: '未推送',
                            send_number: '--'
                        })
                        this.$refs['form'].resetFields();
                    }
                }
            })
        },
        handleDelete(index) {
            this.$confirm('是否删除当前推送时间?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.tableData.splice(index, 1);
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// website/subComponents/push/PushTimes.vue